export const PARTNER_LOGIN_TOKEN = 'pa-v4-token';
export const USER_LOGIN_TOKEN = 'xsolla_login_token_sb';

export const COUNTRY_CODE = 'sb_country_code'; // iso3166, e.g.RU
export const COUNTRY_CODE_3 = 'sb_country_code3'; // e.g. RUS
export const COUNTRY_NAME = 'sb_country_name'; // e.g. Russian Federation
export const LANDING_LOCALE = 'sb-landing-locale'; // e.g. ru-RU
